import Numero from '@/generated/classes/Numero';
export default class NumeroExtend extends Numero {
  constructor() {
    super();
  }
}
